import { type FC } from 'react';
import { type TooltipProps } from './types';
import { type ActivityMarkerFeatureProperties } from '../../types';
import { type Speed } from '../../../../types';
import { Timestamp } from '../../../../services/Timestamp';
import { translateAndFormat } from '../../../../constants/translation';

export const ActivityMarkerTooltip: FC<TooltipProps<ActivityMarkerFeatureProperties> & { timezone: string }> = ({
  properties,
  timezone,
}) => {
  const { timestamp, speed: speedString, type } = properties;
  const speed: Speed = JSON.parse(speedString.toString());
  const offset = Timestamp.fromSeconds(timestamp).toLocationDateTimeOffset(timezone);
  const date = offset.format('hh:mm A');

  return (
    <div className="popup-container">
      <p>{type}</p>
      <p>{translateAndFormat('TIME_AND_SPEED_TOOLTIP_TEXT', date, (speed?.value ?? 0).toFixed(1))}</p>
    </div>
  );
};
